import React from 'react';
import { CtaButton } from './CtaButton';
import { Emoji } from './Emoji';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/eL3wepN3HHhz43LwsM4r44/mock_up_producto_cocina_lista_-_png.png';
const chips = [{
  emoji: '📄',
  label: '100% PDF'
}, {
  emoji: '⚡',
  label: 'Acceso en 5 min'
}, {
  emoji: '⏱️',
  label: '2 hs de cocina'
}];
const trust = [{
  emoji: '🛡️',
  label: 'Garantía 7 días'
}, {
  emoji: '🔒',
  label: 'Pago seguro'
}, {
  emoji: '💳',
  label: 'Mercado Pago'
}];
export function Hero() {
  return <header className="w-full bg-forest-900" data-id="element-119" data-mp="xaxfppm0hsm4">
      <div className="mx-auto flex w-full max-w-[760px] flex-col items-center px-4 pb-8 pt-3 text-center sm:px-6 lg:max-w-[860px] lg:pb-12" data-id="element-120" data-mp="sbb5lp1hcshj">
        <span className="inline-flex items-center gap-2 font-display text-[11px] font-extrabold uppercase tracking-[0.24em] text-cream sm:text-sm" data-id="element-121" data-mp="nbexbdlr2ew6">
          <Emoji symbol="🌿" data-id="element-122" data-mp="382ff5o82r4ex" />
          Close The Gap<span className="text-lime-400" data-id="element-123" data-mp="381e0l9runzsg">™</span>
        </span>

        <h1 className="mt-5 font-display text-[clamp(1.75rem,7.5vw,3.5rem)] font-black leading-[1.02] tracking-tight text-cream" data-id="element-124" data-mp="3j8se7xjcfdo9">
          Tu semana de comida.
          <span className="mt-1 block text-lime-400" data-id="element-125" data-mp="3o6u71a6kmrcx">Lista. Desde hoy.</span>
        </h1>

        <img src={PRODUCT_IMAGE} alt="Mega Pack Cocina Lista: 6 tomos y 6 bonos en PDF sobre batch cooking" className="mt-3 h-auto w-full max-w-[560px]" width={560} height={420} data-id="element-126" data-mp="399tc6xt32ga8" />

        <p className="mt-1 font-display text-sm font-bold tracking-tight text-lime-400 sm:text-lg" data-id="element-127" data-mp="358rdqj6zq89b">
          El sistema de alimentación N°1 para argentinos
        </p>

        <p className="mt-3 max-w-xl text-[14px] leading-relaxed text-cream/75 sm:text-base" data-id="element-128" data-mp="2qlof296xltke">
          Recetas + listas de compras + planificadores + viandas listas para
          llevar. Sin improvisar. Sin delivery de último momento. Sin heladera
          vacía.
        </p>

        <ul className="mt-6 flex w-full flex-wrap items-center justify-center gap-2" data-id="element-129" data-mp="2ljh0dbupvzed">
          {chips.map(chip => <li key={chip.label} className="inline-flex items-center gap-1.5 rounded-full border border-lime-400/20 bg-forest-800 px-3 py-1.5 text-[11px] font-semibold text-cream sm:px-3.5 sm:py-2 sm:text-sm" data-id="element-130" data-mp="s44hnmgsjjhd">
              <Emoji symbol={chip.emoji} data-id="element-131" data-mp="ddwwv03b9odi" />
              {chip.label}
            </li>)}
        </ul>

        <div className="mt-5 w-full max-w-md" data-id="element-132" data-mp="1azumdhg3ytyy">
          <CtaButton emoji="🥗" className="w-full" data-id="element-133" data-mp="1ayjg9az6xa4o">
            Quiero mi Mega Pack ahora
          </CtaButton>
        </div>

        <ul className="mt-5 flex w-full flex-wrap items-center justify-center gap-x-5 gap-y-2" data-id="element-134" data-mp="1126pakv15adm">
          {trust.map(item => <li key={item.label} className="inline-flex items-center gap-1.5 text-[11px] text-cream/70 sm:text-sm" data-id="element-135" data-mp="x0csworvasj9">
              <Emoji symbol={item.emoji} data-id="element-136" data-mp="3hrlmgnykwhbm" />
              {item.label}
            </li>)}
        </ul>
      </div>
    </header>;
}